import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { CustomLinksAttributes } from 'lib/models/custom-links';

const { persistAtom } = recoilPersist({
  key: 'signupSociety',
  storage: process.browser ? localStorage : undefined,
});

export interface CustomLinksAttributesWithSelection
  extends CustomLinksAttributes {
  selected: boolean;
}

export interface SocietyAttributes {
  id?: string;
  name?: string;
  isNewSociety?: boolean;
  isNewUniversity?: boolean;
  university_name?: string;
  university_website?: string;
  university_id?: string;
}

export interface UserAttributes {
  email?: string;
}

interface SignUpSociety {
  user?: UserAttributes;
  society?: SocietyAttributes;
  step: number;
}

export const signUpSocietyState = atom<SignUpSociety>({
  key: 'signUpSociety',
  default: {
    step: 0,
    society: { isNewSociety: false, isNewUniversity: false },
  },
  effects_UNSTABLE: [persistAtom],
});
